import { render, staticRenderFns } from "./AddReturnBill.vue?vue&type=template&id=2ecd5164&scoped=true"
import script from "./AddReturnBill.vue?vue&type=script&lang=js"
export * from "./AddReturnBill.vue?vue&type=script&lang=js"
import style0 from "./AddReturnBill.vue?vue&type=style&index=0&id=2ecd5164&prod&scoped=true&lang=css"
import style1 from "./AddReturnBill.vue?vue&type=style&index=1&id=2ecd5164&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecd5164",
  null
  
)

export default component.exports